import { apiFetch } from "@/lib/api";
import { getFileUrl } from "@/lib/s3";

// Shared signed-URL upload flow: ask the API for a signed PUT URL, push the
// blob straight to it, return the resulting {key, url}. Used anywhere a
// locally-generated blob (a canvas capture, an offscreen render) needs to
// become a real hosted asset.
export async function uploadBlob(
  blob,
  { folder, fileName, fileType = "image/png" },
) {
  const res = await apiFetch("/api/upload", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ fileName, fileType, folder, autoName: true }),
  });
  const { signedUrl, key } = await res.json();
  await fetch(signedUrl, {
    method: "PUT",
    body: blob,
    headers: { "Content-Type": fileType, "x-ms-blob-type": "BlockBlob" },
  });
  return { key, url: getFileUrl(key) };
}
